var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notfound-container"},[_c('img',{staticClass:"image-not-found",attrs:{"src":require(("../assets/" + (this.$device.windows ? 'desktop' : 'mobile') + "/notfound.png")),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }